import type { EdgeElevationNote } from "building-types/edgeBehavior/edgeBehavior";
import { degreeToRadian } from "common/utils/math";

export function elevationNoteMirror(elevationNote: EdgeElevationNote, mirror: boolean): number {
  return degreeToRadian(
    elevationNote.mirrorWithBuilding && mirror ? -(elevationNote.rotation + 360 + 180) : elevationNote.rotation + 360,
  );
}
